export const DERIVED_TO_DATA_ENTRY_HISTORY_MESSAGE =
  "Changing this parameter from Derived to Data Entry will not populate values for existing batches. Historical values will appear blank in SRM Batches.";

export const COPY_BATCH_PARAMETER_TYPE_CHANGE_MESSAGE =
  "Parameters changed from Derived to Data Entry will have blank historical values in the copied batch.";
